import classNames from 'classnames';
import {
  type ComponentPropsWithoutRef,
  forwardRef,
  type ReactNode,
} from 'react';

import styles from './svg-icon.module.css';

export type SvgIconProps = ComponentPropsWithoutRef<'svg'> & {
  size?: number | string;
};

export const SvgIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ size = '1em', className, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      focusable="false"
      {...props}
      className={classNames(styles.icon, className)}
    />
  )
);
SvgIcon.displayName = 'SvgIcon';

export const createSvgIcon = (
  displayName: string,
  viewBox: string,
  paths: ReactNode,
  { size: defaultSize = '1em', ...defaults }: SvgIconProps = {}
) => {
  const Icon = forwardRef<SVGSVGElement, SvgIconProps>(
    ({ size = defaultSize, ...props }, ref) => (
      <SvgIcon ref={ref} viewBox={viewBox} size={size} {...defaults} {...props}>
        {paths}
      </SvgIcon>
    )
  );
  Icon.displayName = displayName;
  return Icon;
};
